import type { MembershipProduct } from "./SpaceType";

export function findUserNotesModule(
  products: MembershipProduct[]
): MembershipProduct | null {
  return products.find((p) => p.productKind === "user_notes") ?? null;
}

export function isUserNotesSubscribed(products: MembershipProduct[]): boolean {
  const mod = findUserNotesModule(products);
  return mod?.userSubscribed === true;
}

export function userNotesRouteKey(products: MembershipProduct[]): string | null {
  const mod = findUserNotesModule(products);
  const id = mod?.spaceProductId?.trim();
  return id || null;
}
